import { Box, Flex, Grid, GridItem, Heading, HStack, Icon, SimpleGrid, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuClapperboard, LuCoins, LuHeadset, LuMousePointerClick } from 'react-icons/lu'
import { useTranslation } from 'react-i18next'

const Advantages = () => {

    const iconBgColor = useColorModeValue('blue.50', 'blue.600')
    const {t} = useTranslation()
    
  return (
    <Flex
        px={{md: 'inherit', '2xl': "19%", base: 4}}
        py={{'2xl' :20, base: 10}}
        overflow={'hidden'}
        position={'relative'}
    >
        <Grid gridTemplateColumns={{md: '1fr 4fr', base : '1fr'}}  gap={{'2xl': '35%', base: 10}}>
            <Box w={'full'}>
                <Heading maxW={'460px'} fontFamily={'Poppins'} letterSpacing={-1.5} lineHeight={1.1} fontSize={{ md: '4xl', '2xl': '5xl', base: '2xl' }} >
                    {t('advantagesTitleServiceOne')}
                </Heading>

                <Text fontSize={{ md: 'lg', '2xl': 'lg', base: 'md' }} fontFamily={'Onest'} mt={{md: 10, base: 4}}>
                    {t('advantagesDescriptionServiceOne')}
                </Text>
            </Box>

            <GridItem>
                <SimpleGrid columns={{md: 2, base: 1}} gap={0}>
                    <HStack  p={4} px={6} align={'start'} gap={4} minH={'160px'} borderRight={{md: '1px solid', base: 'unset'}} borderRightColor={{md: useColorModeValue('gray.100', 'gray.700'), base: 'none'}} borderBottom={'1px solid'} borderBottomColor={useColorModeValue('gray.100', 'gray.700')}>
                        <Box>
                            <Flex justify={'center'} align={'center'} h={'50px'} w={'50px'} bgColor={iconBgColor} rounded={'full'}>
                                <Icon boxSize={6}>
                                    <LuClapperboard/>
                                </Icon>
                            </Flex>
                        </Box>

                        <Box>
                            <Heading fontFamily={'Outfit'}>
                                {t('advantagesChild1TitleServiceOne')}
                            </Heading>
                            <Text mt={1}>
                                {t('advantagesChild1DescriptionServiceOne')}
                            </Text>
                        </Box>
                    </HStack>

                    <HStack p={4} px={6} align={'start'} gap={4} minH={'160px'}  borderBottom={'1px solid'} borderColor={useColorModeValue('gray.100', 'gray.700')}>
                        <Box>
                            <Flex justify={'center'} align={'center'} h={'50px'} w={'50px'} bgColor={iconBgColor} rounded={'full'}>
                                <Icon boxSize={6}>
                                    <LuMousePointerClick/>
                                </Icon>
                            </Flex>
                        </Box>

                        <Box>
                            <Heading fontFamily={'Outfit'}>
                                {t('advantagesChild2TitleServiceOne')}
                            </Heading>
                            <Text mt={1}>
                                {t('advantagesChild2DescriptionServiceOne')}
                            </Text>
                        </Box>
                    </HStack>

                    <HStack p={4} px={6} align={'start'} gap={4} minH={'160px'}  borderRight={{md: '1px solid', base: 'unset'}} borderRightColor={{md: useColorModeValue('gray.100', 'gray.700'), base: 'none'}} borderBottom={{md:'none', base: '1px solid'}} borderBottomColor={useColorModeValue('gray.100', 'gray.700')}>
                        <Box>
                            <Flex justify={'center'} align={'center'} h={'50px'} w={'50px'} bgColor={iconBgColor} rounded={'full'}>
                                <Icon boxSize={6}>
                                    <LuHeadset/>
                                </Icon>
                            </Flex>
                        </Box>

                        <Box>
                            <Heading fontFamily={'Outfit'}>
                                {t('advantagesChild3TitleServiceOne')}
                            </Heading>
                            <Text mt={1}>
                                {t('advantagesChild3DescriptionServiceOne')}
                            </Text>
                        </Box>
                    </HStack>

                    <HStack p={4} px={6} align={'start'} gap={4} minH={'160px'} >
                        <Box>
                            <Flex justify={'center'} align={'center'} h={'50px'} w={'50px'} bgColor={iconBgColor} rounded={'full'}>
                                <Icon boxSize={6}>
                                    <LuCoins/>
                                </Icon>
                            </Flex>
                        </Box>

                        <Box>
                            <Heading fontFamily={'Outfit'}>
                                {t('advantagesChild4TitleServiceOne')}
                            </Heading>
                            <Text mt={1}>
                                {t('advantagesChild4DescriptionServiceOne')}
                            </Text>
                        </Box>
                    </HStack>
                </SimpleGrid>
            </GridItem>
        </Grid>

    </Flex>
  )
}

export default Advantages